var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr-Scene3D_Canvas"},[_c('Spinner',{attrs:{"is-new":true}}),_vm._v(" "),_c('canvas',{ref:"renderCanvas",attrs:{"touch-action":"none"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }